import React from 'react';
import { RefreshCw, X } from 'lucide-react';
import { skipWaiting } from '@/serviceWorkerRegistration';

export default function UpdatePrompt({ onDismiss }) {
  const handleUpdate = () => {
    skipWaiting();
  };

  return (
    <div 
      data-testid="pwa-update-prompt"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl shadow-2xl p-4 animate-in slide-in-from-bottom-5 duration-300"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 bg-white/20 rounded-full p-2">
          <RefreshCw className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-lg">Update Available</h3>
          <p className="text-sm text-white/80 mt-1">
            A new version of SALESSPACE is ready. Refresh to get the latest features and fixes.
          </p>
          <div className="flex gap-2 mt-3">
            <button
              data-testid="pwa-update-button"
              onClick={handleUpdate}
              className="flex-1 bg-white text-blue-600 font-medium py-2 px-4 rounded-lg hover:bg-white/90 transition-colors"
            >
              Update Now
            </button>
            <button
              data-testid="pwa-update-dismiss"
              onClick={onDismiss}
              className="p-2 hover:bg-white/20 rounded-lg transition-colors"
              aria-label="Dismiss"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
